import dayjs from 'dayjs';

const getDaysUntil = (endDate: Date | null | undefined): number => {
  if (!endDate) {
    return 0;
  }
  const today = dayjs();
  const end = dayjs(endDate);
  const diff = end.diff(today, 'day', true);
  return Math.ceil(diff);
};

export default getDaysUntil;
